/**
 * @generated SignedSource<<9c9269db8fc4813c06734d7aade16678>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraNumberFieldFormatStyle = "CURRENCY" | "DECIMAL" | "PERCENT" | "UNIT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type number_issueFieldNumberReadviewFull_NumberReadView$data = {
  readonly formatConfig?: {
    readonly formatStyle: JiraNumberFieldFormatStyle | null | undefined;
    readonly formatUnit: string | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly number: number | null | undefined;
  readonly " $fragmentType": "number_issueFieldNumberReadviewFull_NumberReadView";
};
export type number_issueFieldNumberReadviewFull_NumberReadView$key = {
  readonly " $data"?: number_issueFieldNumberReadviewFull_NumberReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"number_issueFieldNumberReadviewFull_NumberReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "number_issueFieldNumberReadviewFull_NumberReadView",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "number"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraNumberFieldFormatConfig",
          "kind": "LinkedField",
          "name": "formatConfig",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "formatStyle"
            },
            {
              "kind": "ScalarField",
              "name": "formatUnit"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraNumberField"
};

(node as any).hash = "7678fb417f2cd4513c78086113294dc1";

export default node;
